export const ALT_ICON_DOCUMENT= 'card_icon_document';

// Test Only
export const MOCK_CONSTANTS = {
  TITLE: 'Ver prueba técnica',
  URL: 'https://example.com/prueba-tecnica',
  ALT_TEXT: 'card_icon_document',
};